import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  width: 100%;
`;

export const Wrapper = styled.div`
  width: 100%;

  &:not(:last-child) {
    margin-right: 32px;
  }
`;
